module.exports = __webpack_public_path__ + "f196099b325bca15e22b44ee1a4c17f7.png";